import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Subheader from "../UI/Subheader";
import { getOrder } from "../Utils/cart";
import Summary from "../Checkout/Summary";

const FormConfirmation = () => {
  const items = getOrder();
  const categories = useSelector(state => state.purchase.categories);
  const tip = useSelector(state => state.purchase.orderDetails.tip.value);
  const donation = useSelector(state => state.purchase.options.donation);
  const deliveryFee = useSelector(state => state.purchase.options.deliveryFee);
  const takeoutFee = useSelector(state => state.purchase.options.takeoutFee);
  const discount = useSelector(state => state.purchase.options.discount);
  const { facebookPixelID } = useSelector(state => state.settings);

  const orderType = useSelector(
    state => state.purchase.orderDetails.type.value
  );
  const d = donation !== undefined ? donation.amount : 0;
  const a = donation !== undefined ? donation.anonyme : false;
  const confirmedOrderID = useSelector(
    state => state.purchase.confirmedOrderID
  );
  useEffect(() => {
    if (facebookPixelID.value !== "") {
      window.fbq("track", "SubmitApplication");
    }
  }, []);
  return (
    <div className="form-confirmation">
      <h1 style={{ marginTop: 0, paddingTop: 20 }}>Merci !</h1>
      <h3>{`Votre numéro de confirmation est le #${confirmedOrderID}`}</h3>
      <Subheader>Sommaire</Subheader>
      <Summary
        categories={categories}
        items={items}
        tip={tip}
        donation={d}
        anonyme={a}
        orderType={orderType}
        fee={deliveryFee}
        takeoutFee={takeoutFee}
        discount={{
          ...discount,
          valid: !!discount.value
        }}
      />
    </div>
  );
};

export default FormConfirmation;
